import React from "react";
import MyCustomTable from "components/MyCustomTable";
import { Link } from "react-router-dom";

const Servers = () => {
    const columns = React.useMemo(
        () => [
            {
                accessorFn: (row) => row.code,
                accessorKey: "code",
                header: () => (
                    <>
                        <div className="table-cell text-gray-400 md:hidden">
                            <div>CODICE</div>
                            <div>SERVER</div>
                        </div>

                        <span className="hidden text-gray-400 md:table-cell">
                            CODICE SERVER
                        </span>
                    </>
                ),
                enableResizing: false,
                enableSorting: false,
                footer: (props) => props.column.id,
                cell: (props) => (
                    <p className="text-sm text-blue-600">
                        <Link
                            to={{
                                pathname: `/my/server/${props.cell.getValue()}`,
                            }}
                            className="hover:text-blue-500 dark:hover:text-white"
                        >
                            {props.cell.getValue()}
                        </Link>
                    </p>
                ),
            },
            {
                accessorFn: (row) => row.customer,
                accessorKey: "customer",
                enableSorting: false,
                header: () => (
                    <>
                        <span className="table-cell text-gray-400 md:hidden">
                            INFO
                        </span>
                        <span className="hidden text-gray-400 md:table-cell">
                            CLIENTE
                        </span>
                    </>
                ),
                footer: (props) => props.column.id,
                cell: (props) => (
                    <div
                        className="bottom-10 right-10 z-10"
                        style={{
                            textOverflow: "ellipsis",
                            overflow: "auto",
                        }}
                    >
                        <span className="table-cell md:hidden">
                            <p className="text-xs text-gray-800 dark:text-white">
                                {props?.row?.original?.customer}
                            </p>
                            <p className="text-xs text-gray-800 dark:text-white">
                                {props?.row?.original?.type}
                            </p>
                            <p className="text-xs text-gray-800 dark:text-white">
                                {props?.row?.original?.model}
                            </p>
                        </span>
                        <span className="hidden md:table-cell">
                            <p className="text-sm text-gray-800 dark:text-white">
                                {props.cell.getValue()?.toString()}
                            </p>
                        </span>
                    </div>
                ),
            },
            {
                accessorFn: (row) => row.type,
                accessorKey: "type",
                enableSorting: false,
                header: () => <span className="text-gray-400">TIPOLOGIA</span>,
                footer: (props) => props.column.id,
                cell: (props) => (
                    <div
                        className="bottom-10 right-10 z-10"
                        style={{
                            textOverflow: "ellipsis",
                            overflow: "auto",
                        }}
                    >
                        <span>
                            <p className="text-sm text-gray-800 dark:text-white">
                                {props.cell.getValue()?.toString()}
                            </p>
                        </span>
                    </div>
                ),
                meta: { columnClasses: "hidden md:table-cell" },
            },
            {
                accessorFn: (row) => row.model,
                accessorKey: "model",
                enableSorting: false,
                header: () => <span className="text-gray-400">MODELLO</span>,
                footer: (props) => props.column.id,
                cell: (props) => (
                    <div
                        className="bottom-10 right-10 z-10"
                        style={{
                            textOverflow: "ellipsis",
                            overflow: "auto",
                        }}
                    >
                        <span>
                            <p className="text-sm text-gray-800 dark:text-white">
                                {props.cell.getValue()?.toString()}
                            </p>
                        </span>
                    </div>
                ),
                meta: { columnClasses: "hidden md:table-cell" },
            },
            {
                accessorFn: (row) => row.activated_at,
                accessorKey: "activated_at",
                enableSorting: false,
                header: () => (
                    <>
                        <div className="table-cell text-gray-400 md:hidden">
                            <div>ATTIVAZIONE</div>
                            <div>SCADENZA</div>
                            <div>MANUTENZIONE</div>
                            <div>SSL</div>
                        </div>
                        <span className="hidden text-gray-400 md:table-cell">
                            ATTIVAZIONE
                        </span>
                    </>
                ),
                footer: (props) => props.column.id,
                cell: (props) => {
                    return (
                        <div
                            className="bottom-10 right-10 z-10"
                            style={{
                                textOverflow: "ellipsis",
                                overflow: "auto",
                            }}
                        >
                            <span className="table-cell md:hidden">
                                <p className="text-xs text-gray-800 dark:text-white">
                                    {props?.row?.original?.activated_at}
                                </p>
                                <p className="text-xs text-gray-800 dark:text-white">
                                    {props?.row?.original?.expires_at}
                                </p>
                                <p className="text-xs text-gray-800 dark:text-white">
                                    {props?.row?.original?.ssl_expires_at}
                                </p>
                            </span>
                            <span className="hidden md:table-cell">
                                <p className="text-sm text-gray-800 dark:text-white">
                                    {props.cell.getValue()?.toString()}
                                </p>
                            </span>
                        </div>
                    );
                },
            },
            {
                accessorFn: (row) => row.expires_at,
                accessorKey: "expires_at",
                enableSorting: false,
                header: () => (
                    <span className="text-gray-400">SCADENZA MAINTENANCE</span>
                ),
                footer: (props) => props.column.id,
                cell: (props) => (
                    <div
                        className="bottom-10 right-10 z-10"
                        style={{
                            textOverflow: "ellipsis",
                            overflow: "auto",
                        }}
                    >
                        <p className="text-sm text-gray-800 dark:text-white">
                            {props.cell.getValue()}
                        </p>
                    </div>
                ),
                meta: { columnClasses: "hidden md:table-cell" },
            },
            {
                accessorFn: (row) => row.ssl_expires_at,
                accessorKey: "ssl_expires_at",
                enableSorting: false,
                header: (props) => {
                    return (
                        <span className="text-gray-400">
                            SCADENZA CERTIFICATO SSL
                        </span>
                    );
                },
                footer: (props) => props.column.id,
                cell: (props) => (
                    <div
                        className="bottom-10 right-10 z-10"
                        style={{
                            textOverflow: "ellipsis",
                            overflow: "auto",
                        }}
                    >
                        <p className="text-sm text-gray-800 dark:text-white">
                            {props.cell.getValue()}
                        </p>
                    </div>
                ),
                meta: { columnClasses: "hidden md:table-cell" },
            },
        ],
        []
    );

    return (
        <MyCustomTable
            columns={columns}
            endpoint={"/server/list"}
            title={"Server"}
            description={
                <div className="flex flex-col gap-3">
                    <p>Visualizza i dettagli dei tuoi server attivi.</p>
                    <p>
                        Qui, sono elencate le informazioni relative a: cliente
                        finale, tipologia di hardware, modello, stato di
                        attivazione, scadenza della maintenance e del
                        certificato SSL.
                    </p>
                </div>
            }
        />
    );
};

export default Servers;
